import {
  ClipboardSearchResults,
  ClipboardWellDetails,
} from './../../../business/models/CustomModels';
import { CopyWellDetail } from 'business/models/CustomModels';
import { showSnackBar } from 'utils/Global';
import copy from 'copy-html-to-clipboard';
import { LayerDTO } from 'business/models/Models';

export class ClipboardBuffer {
  public database: any;

  async write(data: ClipboardWellDetails[]) {
    try {
      const tab = '</td><td>';
      let strData =
        '<tr><th>Plate Barcode</th><th>Location</th><th>Ingredient</th><th>Conc.</th><th>Unit</th><th>Volume</th><th>Buffer</th><th>pH</th></tr>';
      data.forEach((wellDetail) => {
        strData =
          strData +
          `<tr><td>${wellDetail.plateBarcode}${tab}${wellDetail.location}${tab}${wellDetail.ingredient}${tab}${wellDetail.concentration}${tab}${wellDetail.unit}${tab}${wellDetail.volume}${tab}${wellDetail.buffer}${tab}${wellDetail.ph}</td></tr>\n`;
      });
      copy(
        `<!Doctype html><html><head><title></title></head><body style="font-family:'Times New Roman'"><table border="1">${strData}</table></body></html>`,
        {
          asHtml: true,
        },
      );
      return true;
    } catch (err) {
      console.error(err);
      showSnackBar('Could not copy to clipboard');
    }
    return false;
  }

  async copySearchData(data: ClipboardSearchResults[]) {
    const tab = '</td><td>';
    let strData =
      '<tr><th>Plate ID</th><th>Experiment ID</th><th>Project Name</th><th>File Name</th><th>Plate Name</th><th>Owner</th><th>Barcode</th><th>Date Prepared</th></tr>';
    data.forEach((searchData) => {
      strData += `<tr><td>${searchData.plateId}${tab}${searchData.experimentId}${tab}${searchData.projectName}${tab}${searchData.fileName}${tab}${searchData.plateName}${tab}${searchData.owner}${tab}${searchData.barcode}${tab}${searchData.datePrepared}</td></tr>\n`;
    });
    copy(
      `<!Doctype html><html><head><title></title></head><body style="font-family:'Times New Roman'"><table border="1">${strData}</table></body></html>`,
      {
        asHtml: true,
      },
    );

    return true;
  }

  formatData(data: CopyWellDetail[]) {}

  async writeLayerData(data: LayerDTO) {
    try {
      const tab = '</td><td>';
      let strData = '<tr><th>Plate Barcode</th><th>Width</th></tr>\n';
      strData = strData + `<tr><td>${data.name}${tab}${data.width}</td></tr>\n`;
      copy(
        `<!Doctype html><html><head><title></title></head><body style="font-family:'Times New Roman'"><table border="1">${strData}</table></body></html>`,
        {
          asHtml: true,
        },
      );

      return true;
    } catch (err) {
      console.error(err);
      showSnackBar('Could not copy to clipboard');
    }
    return false;
  }
}
